import React, { useEffect, useState } from "react";
import { api, formatEUR } from "../lib/api";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/orders").then((r) => setOrders(r.data)); }, []);
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-16" data-testid="orders-page">
      <h1 className="font-heading text-4xl tracking-tight font-light text-[#032B44]">I miei ordini</h1>
      <p className="text-slate-600 mt-3 mb-10">Storico completo dei tuoi acquisti.</p>
      {orders.length === 0 ? (
        <div className="text-sm text-slate-500 py-20 text-center bg-sky-50/50 rounded-2xl border border-sky-100" data-testid="orders-empty">
          Nessun ordine ancora.
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <article key={o.order_id} className="bg-white border border-sky-100 rounded-2xl p-6" data-testid={`order-${o.order_id}`}>
              <header className="flex items-start justify-between mb-4 flex-wrap gap-2">
                <div>
                  <p className="text-xs tracking-[0.2em] uppercase font-bold text-sky-600">#{o.order_id.slice(-8)}</p>
                  <p className="font-heading text-lg text-[#032B44] mt-1">
                    {new Date(o.created_at).toLocaleString("it-IT")}
                  </p>
                </div>
                <div className="text-right">
                  <p className="font-heading text-2xl font-semibold text-[#032B44]">{formatEUR(o.total)}</p>
                  <span className={`inline-block mt-1 text-[10px] tracking-wider uppercase font-bold px-2.5 py-0.5 rounded-full border ${
                    o.status === "paid" ? "bg-emerald-50 text-emerald-700 border-emerald-200" :
                    o.status === "awaiting_delivery" ? "bg-indigo-50 text-indigo-700 border-indigo-200" :
                    o.status === "pending" ? "bg-amber-50 text-amber-700 border-amber-200" :
                    "bg-slate-100 text-slate-600 border-slate-200"
                  }`}>
                    {o.status === "paid" ? "Pagato" : o.status === "awaiting_delivery" ? "Alla consegna" : o.status === "pending" ? "In attesa" : "Annullato"}
                  </span>
                </div>
              </header>
              <ul className="text-sm divide-y divide-sky-50">
                {o.items.map((it) => (
                  <li key={`${o.order_id}-${it.product_id}`} className="py-2 flex items-center justify-between">
                    <span className="text-slate-700">{it.name} × {it.quantity}</span>
                    <span className="font-medium text-[#032B44]">{formatEUR(it.subtotal)}</span>
                  </li>
                ))}
              </ul>
              {o.payment_method && (
                <p className="text-xs text-slate-500 mt-3">Pagamento: {o.payment_method === "card" ? "Carta di credito (PayPal)" : o.payment_method === "cash" ? "Contanti alla consegna" : "Conto PayPal"}</p>
              )}
              {o.delivery_slot && (
                <p className="text-xs text-slate-500 mt-1">
                  Fascia consegna: <span className="font-medium text-[#032B44] capitalize">{o.delivery_slot}</span>
                  {o.delivery_date && <span className="ml-1 text-slate-500">· {new Date(o.delivery_date).toLocaleDateString("it-IT")}</span>}
                </p>
              )}
              {o.delivery_address && (
                <p className="text-xs text-slate-500 mt-1">Indirizzo: {o.delivery_address}</p>
              )}
            </article>
          ))}
        </div>
      )}
    </div>
  );
};

export default Orders;
